const invitationRouterPaths = {
  root: '/invitations',
  accept: '/invitations/:invitation',
};

export default invitationRouterPaths;
